import React from 'react';
import PropTypes from "prop-types";
import {Pagination, Button, Spin,Empty} from "antd";
import Item from "./components/Item";
import ReleaseFuzzy from "../../components/ReleaseFuzzy";
import request from "../../../../utils/request";
import qs from 'query-string';
import Lang from "@components/Lang/Lang";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import PageCommon from  "@components/PageCommon/PageCommon";
import "./index.less";
class Page extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            // 客户编号
            id: parseInt(qs.parse(this.props.location.search).id),
            keyword: '',
            list:[],
            extra:{},
            loading:false,
            pagingQuery: {
                pageSize: 50,
                pageIndex: 1,
                total:0
            },
            createTimeBegin: null,
            createTimeEnd: null,
        }
        //默认查近60天
        this.default = {
            // createTimeBegin:moment().startOf("day").subtract(60, 'days'),
            // createTimeEnd:moment().endOf("day")
        }
        this.query = Object.assign({},this.default);
    }
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;

    changeDate(dates) {
        this.setState({
            createTimeBegin: dates[0],
            createTimeEnd: dates[1]
        }, () => {
            this.search();
        })
    }

    changeCheckbox(e){
        this.setState({
              isNew:e.target.checked
          },()=>{
            this.search();
        })
    }

    changeInput(e){
        this.setState({
            keyword:e.target.value
        })
    }

    search(){
        this.query = Object.assign({},{
            keyword:this.state.keyword,
            isNew:this.state.isNew?1:null
        })
        if(this.state.createTimeBegin){
            this.query.createTimeBegin = new Date(this.state.createTimeBegin).setHours(0, 0, 0, 0)
        }
        if(this.state.createTimeEnd){
            this.query.createTimeEnd = new Date(this.state.createTimeEnd).setHours(23, 59, 59, 999)
        }
        this.getData(1);
    }

    onChangePage = (page, pageSize) => {
        this.setState({
            pagingQuery: {
                pageSize: pageSize,
                pageIndex: page
            }
        }, () => {
            this.getData();
        })
    }

    getData(pageIndex){
        this.setState({
            loading:true
        },()=>{
            let state = {
                loading:false
            }
            request.post(
                    "/service/mg/fuzzy/customer/list",
                    {
                        ...this.query,
                        buyerId:this.state.id,
                        pagingQuery: {
                            pageIndex: pageIndex||this.state.pagingQuery.pageIndex,
                            pageSize: this.state.pagingQuery.pageSize,
                        },
                    }
                )
                .then((response) => {
                    const res = response.data;
                    if(res.success&&res.valid){
                        state.list = res.models||[];
                        state.extra = res.extra||{};
                    }
                    //分页
                    if(res.paging){
                        state.pagingQuery = {
                            pageIndex:res.paging.pageNum,
                            pageSize: res.paging.pageSize,
                            total:res.paging.total
                        };
                    }else{
                        state.pagingQuery = {
                            pageSize: 50,
                            pageIndex: 1,
                            total:0
                        };
                    }
                    this.setState(state,()=>{
                        this.onRefPageCommonChild.isShowTop();
                    });
                },()=>{
                    this.setState(state);
                });
        })
    }

    componentDidMount() {
        this.search();
    }

    render(){
        let {pagingQuery,list,extra={}} = this.state;
        const crumb = [
            {name:  Lang({id: "ZhangHaoXiangQing",default: "客户详情"}),link:`/customer/detail?id=${this.state.id}`},
            {name: Lang({id:'KeHuDeZhaoYang',default:"客户的找样"})}
        ];
        return (
            <PageCommon onRef={this.onRefPageCommon} showTop={true}>
                <CommonBreadcrumb list={crumb}></CommonBreadcrumb>
                <div className="fuzzy-list__page">
                    <div className="fuzzy-list__header">
                        <span className="color089 font_16 fw_700 lineH_150p mr_8">
                            {Lang({id:'NDeZhaoYang',default:'{0} 的找样',params:[extra.buyerCode||'-']})}
                        </span>
                        <ReleaseFuzzy buyerId={this.state.id} type={40} callback={this.getData.bind(this,1)}>
                            <Button type="primary">{Lang({id:'FaBuZhaoYang',default:"发布找样"})}</Button>
                        </ReleaseFuzzy>

                        {/*搜索*/}
                        {/*<div className="search-tool antd-blue-btn">
                            <RangePicker
                                className="w_256"
                                format="YYYY-MM-DD"
                                defaultValue={[this.default.createTimeBegin,this.default.createTimeEnd]}
                                placeholder={[__getServerLanguage('KaiShiRiQi'), __getServerLanguage('JieShuRiQi')]}
                                onChange={this.changeDate.bind(this)}/>
                            <Input placeholder={__getServerLanguage('SouSuoZhaoYangMiaoSu')}
                                   value={this.state.keyword}
                                   onChange={this.changeInput.bind(this)}
                                   className="w_315 ml_8"></Input>
                            <Button className="btn-little-blue ml_8"
                                    onClick={this.search.bind(this)}>{__getServerLanguage('SouSuo')}</Button>
                            <Checkbox className="ml_8"
                                      checked={this.state.isNew}
                                      onChange={this.changeCheckbox.bind(this)}>
                                {__getServerLanguage('YouXinHuiFu')} {extra.newReplyCount}
                            </Checkbox>
                        </div>*/}
                    </div>
                    <Spin spinning={this.state.loading}>
                        <div className="fuzzy-list__content">
                            {
                                list.map((item,index)=>{
                                    return <Item key={index} item={item}></Item>
                                })
                            }
                            {
                                list.length==0?
                                    <Empty description={__getServerLanguage('MeiYouChaXunDaoZhaoYangShuJu')}
                                           className="mt_40 mb_40"></Empty>
                                    :
                                    null
                            }

                            {/*分页*/}
                            {
                                pagingQuery.total>0?
                                    <div className="mt_16 mb_16 text-center">
                                        <Pagination
                                            showSizeChanger={false}
                                            current={pagingQuery.pageIndex || 1}
                                            pageSize={pagingQuery.pageSize}
                                            total={pagingQuery.total || 0}
                                            onChange={this.onChangePage.bind(this)}/>
                                    </div>
                                    :
                                    ''
                            }
                        </div>
                    </Spin>
                </div>
            </PageCommon>
        )
    }
}

Page.defaultProps = {
}

Page.propTypes = {

}
export default Page;
